<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/FjbOBs/tc-custom/9781770908123.jpg?1734376544998" alt="This image is the cover for the book Verdict on Each Man Dead, A Peter Cammon Mystery"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Verdict on Each Man Dead, A Peter Cammon Mystery
      </h1>
      <p class="bookDescription body article font2">
        <b>From an Arthur Ellis Award finalist: “An intelligently plotted and layered mystery set in the Mormon heartland” (Brenda Chapman, author of <i>Turning Secrets</i>).</b><br/>  <br/> Peter Cammon is now retired from New Scotland Yard. Nevertheless, the former chief inspector has found himself in the suburbs of Salt Lake City, Utah, after agreeing to help a colleague with a difficult case. A resident on tranquil Hollis Street has been beheaded, her husband has disappeared, and there is no obvious perpetrator. Yet the neighbors seem apathetic—silent to the point of complicity.<br/>  <br/> Peter joins the manhunt and is shocked to discover a link leading from the killer to the Unabomber and Oklahoma City bombing cases, files Peter himself worked on during the 1990s. To untangle the evidence, Peter and his acquaintance in local law enforcement must strike unholy alliances with corrupt cops, Mexican drug lords, and perhaps one of the world’s most notorious terrorists . . . .<br/>  <br/> “Thrilling . . . Whellams, whose thirty-year career in criminal law lends authenticity to his writing, weaves the plot seamlessly through a variety of events to keep readers guessing. This intense, suspenseful, well-crafted mystery will make readers glad that Cammon has not retired.” —<i>Publishers Weekly</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        David Whellams
      </h2>
      
      <p class="authorDescription body article">David Whellams worked for 30 years in criminal law, amending the Criminal Code in such areas as dangerous offenders and terrorism. The first two books in his Peter Cammon Mystery series are Walking Into the Ocean and The Drowned Man. He lives in Ottawa, Ontario.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      ECW Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?83d9889a